import {NgModule} from '@angular/core';
import {EnsureItemSelectedDirective} from './ensure-item-selected.directive';
import {CustomMinDirective} from './validation/custom-min.directive';
import {CustomMaxDirective} from './validation/custom-max.directive';
import {ShowFaSpinnerDirective} from '@shared/directives/show-fa-spinner.directive';
import {MustMatchDirective} from './validation/must-match.directive';
import {UniqueItemValidatorDirective} from './validation/unique-item-validator.directive';
import {ValidEmailValidatorDirective} from './validation/valid-email-validator.directive';
import {LastClickInsideDirective} from './last-click-inside.directive';
import {BrowserTabTitleActivatedRouteComponentsDirective} from './browser-tab-title-activated-route-components.directive';
import {ResizeDirective} from './resize.directive';
import {DynamicHeightVirtualScrollDirective} from "@shared/directives/dynamic-height-virtual-scroll-strategy/dynamic-height-virtual-scroll.directive";
import {NgIfAnimateDirective} from './animate/ng-if-animate.directive';
import {NgIfExpandDirective} from './animate/ng-if-expand.directive';
import {TooltipWhenTruncatedDirective} from './tooltip-when-truncated.directive';

@NgModule({
  imports: [NgIfAnimateDirective, NgIfExpandDirective, TooltipWhenTruncatedDirective],
  declarations: [
    EnsureItemSelectedDirective,
    CustomMinDirective,
    CustomMaxDirective,
    ShowFaSpinnerDirective,
    MustMatchDirective,
    UniqueItemValidatorDirective,
    ValidEmailValidatorDirective,
    LastClickInsideDirective,
    BrowserTabTitleActivatedRouteComponentsDirective,
    ResizeDirective,
    DynamicHeightVirtualScrollDirective
   ],
  exports: [
    EnsureItemSelectedDirective,
    CustomMinDirective,
    CustomMaxDirective,
    ShowFaSpinnerDirective,
    MustMatchDirective,
    UniqueItemValidatorDirective,
    ValidEmailValidatorDirective,
    LastClickInsideDirective,
    BrowserTabTitleActivatedRouteComponentsDirective,
    ResizeDirective,
    DynamicHeightVirtualScrollDirective,
    NgIfAnimateDirective,
    NgIfExpandDirective,
    TooltipWhenTruncatedDirective
  ]
})
export class SharedDirectivesModule {
}
